import React from 'react';
import { Card, Tag } from 'antd';
import { BellOutlined, MailOutlined, CalendarOutlined, TeamOutlined } from '@ant-design/icons';
import { formatDateTime, formatLeadSource } from '../../../../utils/functions';

const EnhancedNewLeadAlertCardView = ({ record, onCardClick }) => {
    const alertContact = record.alertEmail || record.alertSms || "N/A";
    const leadSourceName = formatLeadSource(record?.leadSourceId?.leadSource) || "N/A";

    return (
        <Card
            hoverable
            className="h-full relative shadow-sm hover:shadow-md transition-shadow"
            onClick={() => onCardClick && onCardClick(record)}
            bodyStyle={{ padding: '16px' }}
        >
            <div className="flex flex-col gap-3">
                <div className="flex justify-between items-start">
                    <Tag color="geekblue" className="capitalize m-0 font-medium">
                        {leadSourceName}
                    </Tag>
                    <span className="text-xs text-gray-500 flex items-center gap-1">
                        <CalendarOutlined />
                        {formatDateTime(record.createdAt)}
                    </span>
                </div>

                <div className="flex items-start gap-2 mt-1">
                    <BellOutlined className="mt-1 text-primary" />
                    <span className="text-sm font-semibold text-gray-800 break-all">
                        {alertContact}
                    </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-600 mt-auto pt-2 border-t border-gray-100">
                    <TeamOutlined />
                    <span>Leads: {record.leadsImported || 0}</span>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedNewLeadAlertCardView;
